export default __webpack_public_path__ + "static/epilogue-07a9e8b705fcba6c8478a6e9c70d8d87.svg";